import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle, Star, BookMarked, Gift, Sparkles, Crown } from 'lucide-react';
const baseFeatures = [{
  text: '6 tomos principales del MegaPack',
  included: true
}, {
  text: '6 bonos digitales',
  included: true
}, {
  text: 'Acceso inmediato y pago único',
  included: true
}, {
  text: 'Acceso a FonoClinic OS™ Profesional',
  included: false
}, {
  text: '5 módulos premium ampliados',
  included: false
}, {
  text: 'Recursos extra de seguimiento, informes y gestión',
  included: false
}];
const premiumFeatures = [{
  text: 'Todo lo de la Oferta Base',
  highlight: true
}, {
  text: 'Acceso a FonoClinic OS™ Profesional',
  highlight: true
}, {
  text: '5 módulos premium ampliados',
  highlight: true
}, {
  text: 'Más recursos de seguimiento, informes y gestión'
}];
export function Pricing() {
  return <section className="py-12 bg-transparent relative" id="pricing" data-id="element-133">
      <div className="container mx-auto px-6 max-w-6xl relative z-10" data-id="element-134">
        <div className="text-center mb-14 max-w-3xl mx-auto" data-id="element-135">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-orange-500/10 border border-orange-500/30 text-orange-300 text-[11px] font-bold tracking-[0.18em] uppercase mb-5" data-id="element-136">
            <Sparkles className="w-3.5 h-3.5" data-id="element-137" />
            Elegí tu plan
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold mb-5 leading-tight" data-id="element-138">
            Elegí la versión que mejor se adapte a{' '}
            <span className="text-gradient" data-id="element-139">tu momento profesional</span>
          </h2>
          <p className="text-lg text-gray-400" data-id="element-140">
            Ambas opciones te dan acceso a recursos de alto valor, pero una está
            pensada para profesionales que quieren resolverlo de forma más
            completa.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-6 lg:gap-8 items-stretch max-w-5xl mx-auto" data-id="element-141">
          {/* Oferta Base */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="glass-card rounded-3xl p-8 border border-white/10 relative flex flex-col" data-id="element-142">
            <div className="inline-block self-start px-3 py-1 rounded-full bg-white/5 border border-white/10 text-gray-400 text-xs font-semibold tracking-wider uppercase mb-5" data-id="element-143">
              Para empezar
            </div>

            <h3 className="text-2xl font-bold text-white mb-1" data-id="element-144">Oferta Base</h3>
            <div className="flex items-baseline gap-2 mb-5" data-id="element-145">
              <span className="text-4xl font-black text-white" data-id="element-146">$19.990</span>
              <span className="text-xs text-gray-500 font-medium" data-id="element-147">
                pago único
              </span>
            </div>

            <div className="text-[11px] uppercase tracking-wider text-gray-500 font-bold mb-3" data-id="element-148">
              Incluye
            </div>
            <ul className="space-y-3 mb-8 flex-1" data-id="element-149">
              {baseFeatures.map((item, i) => <li key={i} className={`flex items-start gap-3 text-[14px] leading-snug ${item.included ? 'text-gray-300' : 'text-gray-600 line-through'}`} data-id="element-150">
                  {item.included ? <CheckCircle2 className="w-5 h-5 text-gray-400 shrink-0 mt-0.5" data-id="element-151" /> : <XCircle className="w-5 h-5 text-gray-700 shrink-0 mt-0.5" data-id="element-152" />}
                  <span data-id="element-153">{item.text}</span>
                </li>)}
            </ul>

            <a href="https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNCDIsvLps4JbYs2ShKleCI/es-ar?_r=AQABDZcD4EZ_R4bO-RGk8fxVA9BNiMzeRvoNy4Iv7zXKErU&cart_link_id=Ci1IcshE&preview_theme_id=151828791463" target="_blank" rel="noopener noreferrer" className="block w-full text-center py-4 rounded-xl bg-[#1f1f1f] border border-orange-500/30 text-white font-bold tracking-wide hover:bg-[#2a2a2a] hover:border-orange-500/60 transition-colors" data-id="element-154">
              QUIERO ESTA OPCIÓN
            </a>
          </motion.div>

          {/* Oferta Premium */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative rounded-3xl p-8 md:p-10 border-2 border-orange-500 bg-gradient-to-b from-[#1a1108] via-[#120a05] to-[#0a0604] shadow-[0_0_50px_rgba(255,140,0,0.25)] flex flex-col lg:-translate-y-2 overflow-hidden" data-id="element-155">
            {/* Subtle top highlight */}
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-orange-400/70 to-transparent" data-id="element-156" />

            {/* Top recommended badge */}
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 px-5 py-1.5 rounded-full bg-gradient-primary text-white text-xs font-extrabold tracking-wider shadow-[0_0_25px_rgba(255,140,0,0.6)] flex items-center gap-2 whitespace-nowrap uppercase" data-id="element-157">
              <Star className="w-3.5 h-3.5 fill-current" data-id="element-158" />
              La más elegida
            </div>

            <div className="inline-flex items-center self-start gap-1.5 px-3 py-1 rounded-full bg-orange-500/15 border border-orange-400/40 text-orange-300 text-xs font-bold tracking-wider uppercase mb-5 mt-2" data-id="element-159">
              <Crown className="w-3 h-3" data-id="element-160" />
              Versión más completa
            </div>

            <h3 className="text-white mb-1 text-[18px] font-[900] font-[Poppins,_sans-serif]" data-id="element-161">
              Megapack fonoaudiologia + FONOCLINIC OS™
            </h3>
            <div className="flex items-baseline gap-2 mb-5" data-id="element-162">
              <span className="text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-yellow-400" data-id="element-163">
                $27.990
              </span>
              <span className="text-xs text-orange-300/70 font-medium" data-id="element-164">
                pago único
              </span>
            </div>

            <div className="text-[11px] uppercase tracking-wider text-orange-400 font-bold mb-3" data-id="element-165">
              Todo lo que incluye
            </div>
            <ul className="space-y-2.5 mb-8 flex-1" data-id="element-166">
              {premiumFeatures.map((item, i) => <li key={i} className={`flex items-start gap-3 text-[14px] leading-snug ${item.highlight ? 'text-white font-semibold' : 'text-gray-200'}`} data-id="element-167">
                  <CheckCircle2 className={`w-5 h-5 shrink-0 mt-0.5 ${item.highlight ? 'text-orange-400' : 'text-orange-500/70'}`} data-id="element-168" />
                  <span data-id="element-169">{item.text}</span>
                </li>)}
            </ul>

            <a id="premium-cta" href="https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNCDJMRQBLBUCI1HjQx2SlG/es-ar?_r=AQABc68WTaOexRri15OV7_gxwb9LKhcE7Pu7dl-v4a1vTjo&cart_link_id=9kNmNhJW&preview_theme_id=151828791463" target="_blank" rel="noopener noreferrer" className="block w-full text-center py-5 rounded-xl bg-gradient-primary text-white font-extrabold text-lg tracking-wide shadow-[0_0_35px_rgba(255,140,0,0.55)] hover:shadow-[0_0_50px_rgba(255,140,0,0.75)] hover:-translate-y-0.5 transition-all mb-3 scroll-mt-24 uppercase" data-id="element-170">
              Quiero la oferta más completa
            </a>

            <p className="text-center text-xs text-orange-200/70 font-medium" data-id="element-171">
              La mejor decisión si querés invertir una vez y acceder a la
              versión más poderosa del MegaPack.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}